import { render, staticRenderFns } from "./DeviceActions.vue?vue&type=template&id=24ca09f4&scoped=true"
import script from "./DeviceActions.vue?vue&type=script&lang=ts"
export * from "./DeviceActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ca09f4",
  null
  
)

export default component.exports